// Mock data for Heathbourne House Childcare

export const childcareData = {
  hero: {
    title: "Heathbourne House Childcare",
    subtitle: "Nurturing young minds in a beautiful Georgian home since 2016",
    description: "A unique childcare setting in Bushey Heath with exceptional care and learning",
    cta: "Book a Tour",
    backgroundImages: [
      "https://customer-assets.emergentagent.com/job_romantic-brahmagupta/artifacts/fsvyplu1_image.png",
      "https://customer-assets.emergentagent.com/job_romantic-brahmagupta/artifacts/2y9qxjj3_image.png"
    ]
  },
  
  about: {
    title: "About Heathbourne House",
    description: "Set in a gorgeous Georgian/Victorian house from 1837, Heathbourne House offers a truly unique childcare experience.",
    features: [
      {
        icon: "Heart",
        title: "Experienced Founders",
        description: "Liza and Jasmin bring decades of childcare expertise and genuine care"
      },
      {
        icon: "Award",
        title: "Professional Curriculum",
        description: "Following Early Years Foundation Stage with added unique activities"
      },
      {
        icon: "Shield",
        title: "Fully Certified & Qualified",
        description: "Ofsted registered, Level 2 Food Hygiene certified, NVQ certified, and Paediatric First Aid certified staff"
      },
      {
        icon: "TreePine",
        title: "2 Acres of Natural Beauty",
        description: "Expansive gardens with animals, tennis court, and outdoor learning spaces"
      }
    ],
    
    foundersInfo: [
      {
        name: "Liza Gale",
        role: "Co-Founder & Lead Childcare Provider",
        experience: "Mother of 5 children",
        qualifications: "NVQ Certified • Paediatric First Aid Certified",
        specialization: "Onboarding & Family Support",
        description: "Liza has dedicated her life to looking after children with an innate motherly instinct, bringing warmth and expertise to every child's journey.",
        phone: "+447870556812",
        photo: "https://customer-assets.emergentagent.com/job_romantic-brahmagupta/artifacts/fuv4uesb_image.png"
      },
      {
        name: "Jasmin Gale",
        role: "Co-Founder & Operations Manager",
        experience: "15 years in childcare",
        qualifications: "NVQ Certified • Paediatric First Aid Certified",
        specialization: "Operations & Daily Activities", 
        description: "Jasmin brings extensive childcare experience and operational excellence, ensuring smooth daily operations and exceptional care quality.",
        phone: "+447592540968",
        photo: "https://customer-assets.emergentagent.com/job_romantic-brahmagupta/artifacts/njhfdcj7_image.png"
      }
    ],

    settlerRegime: {
      title: "Tested Settler Regime",
      description: "We understand that starting childcare can be a big step for both children and parents. Our tried and tested settler regime helps new children transition smoothly into our environment, ensuring they feel comfortable, secure, and happy.",
      steps: [
        {
          step: 1,
          title: "Initial Visit",
          description: "Parent and child visit together to explore our facilities"
        },
        {
          step: 2, 
          title: "Short Sessions",
          description: "Gradual introduction with shorter initial sessions"
        },
        {
          step: 3,
          title: "Full Integration", 
          description: "Child becomes fully comfortable and confident in our care"
        }
      ]
    }
  },

  services: {
    title: "Our Services & Curriculum",
    ageRange: "Ages 1-5 years",
    hours: "8:30am - 4:30pm, Monday to Friday",
    operatingSchedule: {
      yearRound: "Open all year round",
      holidays: "Closed for 2 weeks in summer (August) and 2 weeks at Christmas",
      options: [
        {
          type: "All Year Round",
          description: "Full childcare service throughout the year (except holiday closures)"
        },
        {
          type: "Term Time Only", 
          description: "Childcare service following school term dates"
        }
      ]
    },
    price: "£10 per hour (including healthy meals and snacks)",
    eyfsCore: {
      title: "Early Years Foundation Stage (EYFS)",
      description: "Our primary curriculum follows the EYFS framework, tailored to each age group's developmental needs",
      ageGroups: [
        {
          age: "1-2 Years",
          title: "Explorers",
          focus: [
            "Sensory exploration and discovery",
            "Basic communication skills",
            "Motor skill development",
            "Social interaction basics",
            "Routine establishment"
          ]
        },
        {
          age: "2-3 Years", 
          title: "Discoverers",
          focus: [
            "Language and vocabulary expansion",
            "Creative expression through art",
            "Independence skills",
            "Emotional recognition",
            "Early numeracy concepts"
          ]
        },
        {
          age: "3-5 Years",
          title: "Adventurers", 
          focus: [
            "School readiness preparation",
            "Advanced literacy skills",
            "Mathematical concepts",  
            "Critical thinking",
            "Leadership and cooperation"
          ]
        }
      ],
      learningAreas: [
        {
          title: "Communication & Language",
          description: "Listening, attention, understanding, and speaking skills",
          icon: "MessageCircle"
        },
        {
          title: "Physical Development",
          description: "Moving, handling, and health & self-care",
          icon: "Activity"
        },
        {
          title: "Personal, Social & Emotional",
          description: "Self-confidence, managing feelings, and relationships",
          icon: "Heart"
        },
        {
          title: "Literacy",
          description: "Reading and writing skills development",
          icon: "BookOpen"
        },
        {
          title: "Mathematics",
          description: "Numbers, shape, space, and problem-solving",
          icon: "Calculator"
        },
        {
          title: "Understanding the World",
          description: "People, communities, technology, and nature",
          icon: "Globe"
        },
        {
          title: "Expressive Arts & Design",
          description: "Art, music, cooking, baking, messy play activities",
          icon: "Palette"
        }
      ]
    },
    uniqueCurriculum: {
      title: "What Makes Us Special",
      description: "Beyond our core curriculum, we offer unique activities that make us truly special",
      activities: [
        {
          title: "Animal Care",
          description: "Pet tortoise, chickens, nature observing, feeding ducks at the pond",
          icon: "Heart"
        },
        {
          title: "Professional Football Coaching", 
          description: "Age-appropriate football skills and teamwork",
          icon: "Users"
        },
        {
          title: "French Language Learning",
          description: "Introduction to French through songs and games",
          icon: "BookOpen"
        },
        {
          title: "Yoga & Movement",
          description: "Mindfulness and physical development",
          icon: "Star"
        },
        {
          title: "Music & Rhythm",
          description: "Musical exploration and instrument play",
          icon: "Music"
        },
        {
          title: "Nature Exploration & Walks", 
          description: "Discovery walks around our 2-acre grounds",
          icon: "TreePine"
        }
      ]
    },
    facilities: [
      "2-acre private grounds",
      "Tennis court access", 
      "Bug garden exploration",
      "Farm animals (dogs, rabbits, chickens)",
      "Indoor & outdoor play areas",
      "Nutritious meal preparation"
    ]
  },

  funding: {
    title: "Government Funding Available",
    subtitle: "Up to 30 hours free childcare per week",
    eligibility: [
      "Children aged 9 months to 3 years",
      "Both parents working (minimum 16 hours/week)",
      "Annual income between £9,518 - £100,000", 
      "38 weeks per year coverage"
    ],
    howToApply: [
      "Apply through Childcare Choices website",
      "Apply mid-January to end of February for September start",
      "Receive confirmation code for your provider",
      "Reconfirm eligibility every 3 months"
    ],
    hoursBreakdown: [
      {
        age: "9 months - 2 years",
        hoursWeekly: "Up to 30 hours",
        hoursYearly: "1,140 hours (38 weeks)",
        valueYearly: "£11,400",
        startWhen: "Available immediately if eligible"
      },
      {
        age: "2 - 3 years", 
        hoursWeekly: "Up to 30 hours",
        hoursYearly: "1,140 hours (38 weeks)",
        valueYearly: "£11,400",
        startWhen: "Available immediately if eligible"
      }
    ]
  },

  testimonials: [
    {
      name: "Sophie",
      child: "Henry",
      text: "Henry started Heathbourne House at 15 months old. It was the first childcare setting I had put him in, and he was so happy there. He loved the staff, and every single one of them was so warm, loving, and caring, and looked after Henry like he was one of their own. His speech developed more after a few months of being there — he learnt how to count to 20, and also in French. The nursery itself is so spacious, with lovely things to do including the nursery's pet tortoise, the chickens, and the tennis courts. I've always said that Heathbourne felt like dropping Henry off at family, and I will be sending my daughter in the future.",
      rating: 5
    },
    {
      name: "Lisa and Jamie Little",
      child: "Jack",
      text: "We couldn't be happier with our experience at Heathbourne House. From the moment we drop Jack off to when we collect him, he is always so excited and full of joy. The warmth, care, and attention he receives every day is truly special, and it shines through in how much he loves his time there. The team consistently go above and beyond to create a nurturing and stimulating environment, and we couldn't ask for more. Jack always comes home happy, full of stories, and we can see how much he is learning and growing. As parents, it gives us so much peace of mind knowing he is surrounded by such kindness and support. We feel incredibly lucky to have found Heathbourne House and are deeply grateful for the wonderful start it has given Jack.",
      rating: 5
    },
    {
      name: "Collette",
      child: "Parent",
      text: "Heathbourne House is the most incredible environment for my child, she feels safe, happy and at home. Their facilities are fantastic and there is a deep care for the children to explore, learn and grow together. My child has been incredibly happy here.",
      rating: 5
    },
    {
      name: "Jodie",
      child: "Daisy (started at 10 months)",
      text: "Sending Daisy to Heathbourne House was the best decision we could have made. She was only 10 months old at the time, but she quickly became part of the Heathbourne family, where she was cared for as if she were their own. Not only did she thrive and learn so much, but she was always excited and happy to go into nursery each day. We absolutely loved all the staff - they were warm, nurturing, and truly dedicated. We would recommend Heathbourne House any day to any parent looking for a safe and loving environment for their child.",
      rating: 5
    },
    {
      name: "Kayleigh",
      child: "My little girl",
      text: "Heathbourne house provides such a nurturing environment with amazing childminders who are so kind and caring. My little girl has been there for a year now and is absolutely thriving. She settled so well from day one and has become so confident and sociable. I love how many toys and activities there are and the large outdoor space they have is fabulous. I am so glad I chose here for my daughter, she loves it so much and is so happy to be there, I cannot recommend enough.",
      rating: 5
    },
    {
      name: "Mahrez's Mum",
      child: "Mahrez (2.5 years)",
      text: "I have had a wonderful experience with the nursery. My 2.5-year-old son, Mahrez, started attending a couple of days a week after being used to spending all his time with me. The staff were incredibly helpful, patient, and accommodating in supporting him as he settled in. I feel this setting truly excels at helping children transition into their first out-of-home experience. The environment is nurturing, adaptable, and committed to creating a 'home away from home.' The welcoming atmosphere together with the size of the setting makes it feel warm, personal, and not at all overwhelming. We're so grateful to have found such a wonderful place for our son.",
      rating: 5
    }
  ],

  gallery: [
    {
      url: "https://customer-assets.emergentagent.com/job_30df0788-29ee-48d3-84a9-89ecbb62c5b6/artifacts/yyu61zk7_PHOTO-2025-08-25-17-46-27-1.jpg",
      alt: "Indoor playroom with checkered floor and learning areas"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_30df0788-29ee-48d3-84a9-89ecbb62c5b6/artifacts/jv9361xi_PHOTO-2025-08-25-17-46-27-2.jpg", 
      alt: "Graduate celebration - Class 2025"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_30df0788-29ee-48d3-84a9-89ecbb62c5b6/artifacts/diz20iaf_PHOTO-2025-08-25-17-46-27-3.jpg",
      alt: "Creative play area with bunting and activities"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_30df0788-29ee-48d3-84a9-89ecbb62c5b6/artifacts/h4d526sc_PHOTO-2025-08-25-17-46-28-1.jpg",
      alt: "Outdoor garden and patio area with play equipment"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_cozy-care/artifacts/kj8783uy_PHOTO-2025-08-25-17-46-28-2.jpg",
      alt: "Reading corner with books and cozy seating"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_cozy-care/artifacts/t4wdmztk_PHOTO-2025-08-25-17-46-28.jpg",
      alt: "Beautiful garden space with lawn and natural boundaries"  
    },
    {
      url: "https://customer-assets.emergentagent.com/job_cozy-care/artifacts/iw4e59x3_PHOTO-2025-08-25-17-46-29-1.jpg",
      alt: "Children enjoying outdoor slide and play activities"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_cozy-care/artifacts/j2ayrzfs_PHOTO-2025-08-25-17-46-29-2.jpg", 
      alt: "Interactive learning with children at blackboard"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_cozy-care/artifacts/s2m2fhrj_PHOTO-2025-08-25-17-46-29-3.jpg",
      alt: "Additional indoor play area with toys and activities"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_cozy-care/artifacts/5hhzbnlf_PHOTO-2025-08-25-17-46-29.jpg",
      alt: "Outdoor garden with natural play areas"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_cozy-care/artifacts/tdz618pk_PHOTO-2025-08-25-17-46-30-1.jpg",
      alt: "Indoor creative learning space"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_cozy-care/artifacts/4y0hdabl_PHOTO-2025-08-25-17-46-30-2.jpg",
      alt: "Children engaged in activities"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_cozy-care/artifacts/x0u2kqgo_PHOTO-2025-08-25-17-46-30-3.jpg",
      alt: "Outdoor learning environment"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_cozy-care/artifacts/zd9ai8yg_PHOTO-2025-08-25-17-46-30-4.jpg",
      alt: "Natural outdoor play space"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_cozy-care/artifacts/o386cjn6_PHOTO-2025-08-25-17-46-30.jpg",
      alt: "Beautiful indoor learning environment with natural light"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_cozy-care/artifacts/9h08h9ex_PHOTO-2025-08-25-17-46-31-1.jpg",
      alt: "Cozy indoor play space"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_cozy-care/artifacts/ykkk7otj_PHOTO-2025-08-25-17-46-31-2.jpg",
      alt: "Learning activities and play area"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_cozy-care/artifacts/84obe5g6_PHOTO-2025-08-25-17-46-31-3.jpg",
      alt: "Creative indoor space with educational materials"
    }
  ],

  contact: {
    email: "heathbournehousechildminder@gmail.com",
    phones: {
      primary: "+447592540968",
      secondary: "+447870556812"
    },
    names: {
      primary: "Jasmin Gale",
      secondary: "Liza Gale"
    },
    address: "WD23 1PA, Bushey Heath, UK",
    whatsapp: {
      jasmin: "+447592540968",
      liza: "+447870556812"
    },
    instagram: "https://www.instagram.com/heathbournehouse/"
  },

  referral: {
    amount: "£100",
    description: "Earn £100 for each successful referral (paid after first month completed)",
    email: "heathbournehousechildminder@gmail.com",
    detailedTerms: {
      howItWorks: [
        "Your friend must mention that you referred them when they first contact us",
        "They must sign up and pay for their first month of childcare",
        "The first month must include at least 50 hours of childcare",
        "Once these conditions are met, £100 will be transferred to your bank account",
        "Payment is typically processed within 5-7 business days after qualification"
      ],
      conditions: [
        "Referral must be mentioned at initial contact",
        "Minimum 50 hours in first month required", 
        "Payment after first month completion",
        "One referral bonus per new family",
        "Referral bonus applies to paying families only"
      ],
      contactForDetails: "For questions about referrals or to provide your bank details for payment, email us at heathbournehousechildminder@gmail.com"
    }
  }
};